import { render, staticRenderFns } from "./activityIntroduction.vue?vue&type=template&id=b57cbaaa&scoped=true"
import script from "./activityIntroduction.vue?vue&type=script&lang=js"
export * from "./activityIntroduction.vue?vue&type=script&lang=js"
import style0 from "./activityIntroduction.vue?vue&type=style&index=0&id=b57cbaaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57cbaaa",
  null
  
)

export default component.exports